<input
  [ngStyle]="overrideStyle"
  type="time"
  class="time-component"
  [(ngModel)]="timeValue"
  (blur)="onBlur()"
  min="00:00"
  max="24:00"
/>
